import { HDSAvatar } from '@here/hds-react-components'
import React from 'react'

import { HereAccount } from '../data/reducer'
import { createInitials } from '../lib/utils'

interface UserMenuHeader {
  user: HereAccount
  imageUrl?: string
}

export function UserMenuHeader({ user, imageUrl }: UserMenuHeader): JSX.Element {
  const name = createInitials(user)
  return (
    <>
      <HDSAvatar name={name} imageUrl={imageUrl} size="large" />
      <span className="UserMenu__title">{user.name}</span>
      <span className="UserMenu__subtitle">{user.email}</span>
    </>
  )
}
